<template>
	<!---  subStep 0 (category - country - entity) -->
	<div class="register-first-step">
		<div class="entity-container">
			<div class="titles">
				<h3 class="login-form__title">
					{{ $t('register.titleRegister') }}
				</h3>
				<p class="linkRegistro">
					{{ $t('register.AccountDesc') }}
				</p>
			</div>

			<div class="col-12 xl:col-12">
				<TVRadioButton
					id="tax-purposes_app-process-form"
					v-model="accountValue"
					name="usacompany"
					:label="$t('register.AccountChoose')"
					:options="accountsOpt"
					class="app-process-style large"
					@update:model-value="
						(val) => handleInputChange(val)
					"
				/>
			</div>

			<div class="entities-inputs">
				<TVInputSelect
					v-if="liveAccount"
					id="accountCategory"
					v-model="accountCategory"
					name="accountCategory"
					:label="$t('register.accountCategory')"
					:placeholder="$t('register.accountCategoryPlaceholder')"
					:options="accountOptions"
					:tooltip-message="$t('register.accountCategoryTooltip')"
					:tooltip-dir-desk="tooltipDirection"
					tooltip-dir-mobile="top"
					:tooltip-max-width="246"
					style="width: 100%"
				/>

				<CountryEntity @updateCountryEntity="updateCountryEntity" />
			</div>
		</div>

		<div
			class="disclaimer entityDisclaimer"
			:class="showDisclaimer ? '' : 'style-white'"
			v-if="showBoxDisclaimer"
		>
			<div class="disclaimer-conatainer">
				<div class="disclaimer-btn" @click="toggleDisclaimer()">
					<p>{{ $t('register.entitiesTitle') }}</p>
					<img
						src="/assets/images/arrow.svg"
						:class="showDisclaimer ? '' : 'rotate'"
						alt=""
					/>
				</div>
				<div class="text-disclaimer">
					<p
						class="item-disc"
						v-if="showDisclaimer && !isCountryEurope"
						v-html="$t('register.entitiesDesc')"
					></p>
					<p
						class="item-disc"
						v-if="showDisclaimer && isCountryEurope"
						v-html="$t('register.entitiesDescEu')"
					></p>
				</div>
			</div>
		</div>

		<div class="btn-register-first">
			<button
				class="red-button"
				id="btnSubConf"
				:disabled="allowBtn"
				@click="validateEntity()"
			>
				{{ $t('register.getstarted') }}
			</button>
		</div>
	</div>
</template>

<script>
import { ref, computed, watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'

import TVInputSelect from '../../../modules/ui/TVInputSelect.vue'
import TVRadioButton from '../../../modules/ui/TVRadioButton.vue'
import { i18n } from '@/plugins/i18n'
import { getTooltipDirection } from '@/_helpers/stylesArabic.js'
import CountryEntity from './CountryEntity.vue'
import { accountsOptions } from '../../../modules/helpers/arraysAppProcess'
const language = localStorage.getItem('language')
const router = useRouter()

export default {
	name: 'First Step Register',
	components: {
		TVInputSelect,
		CountryEntity,
		TVRadioButton,
	},
	props: {
		liveAccount: Boolean,
	},
	emits: ['updateCountryEntity', 'changeViewStep'],
	setup(props, { emit }) {

		let accountCategory = ref('INDIVIDUAL')
		let countryofRecidency = ref(null)
		let entity = ref(null)
		let initialEntity = ref(null)
		let accountOptions = ref([
			{
				value: 'INDIVIDUAL',
				text: i18n.global.t('register.individual'),
			},
			{
				value: 'CORPORATE',
				text: i18n.global.t('register.corporate'),
			},
		])
		if (language !== 'jp') {
			accountOptions.value = [
				...accountOptions.value,
				{
					value: 'JOINT',
					text: i18n.global.t('register.joint'),
				},
			]
		}

		let tooltipDirection = ref(getTooltipDirection())
		let showDisclaimer = ref(true)
		let accountValue = ref(null) //(true) = live  (false) = demo
		const accountsOpt = ref(accountsOptions)
		let showBoxDisclaimer = ref(null)

		const allowBtn = computed(() => {
			let validate
			if (window.location.pathname.includes('live-account')) {
				validate =
					accountCategory.value && countryofRecidency.value && entity.value
			}
			if (window.location.pathname.includes('demo-account')) {
				validate = countryofRecidency.value && entity.value
			}

			if (entity.value && countryofRecidency.value) {
				localStorage.setItem('countryValue', countryofRecidency.value)
				localStorage.setItem('entityValue', entity.value)
			}

			localStorage.setItem('accountTypeCreate', accountCategory.value)

			return validate !== null ? false : true
		})

		let isCountryEurope = ref(null)

		const updateCountryEntity = (data) => {
			isCountryEurope.value = data.isCountryEurope
			countryofRecidency.value = data.countryofRecidency
			entity.value = data.entity
			initialEntity.value = data.initialEntity
			data.accountCategory = accountCategory.value
			emit('updateCountryEntity', data)
		}

		const toggleDisclaimer = () => {
			showDisclaimer.value = !showDisclaimer.value
		}

		const validateEntity = () => {
			if (entity.value === 'EUROPA') {
				window.open('https://cabinet.tradeview.eu/register/1/live-account')
			} else if (entity.value === 'GLOBAL') {
				window.open('https://www.tvmgloballtd.com/accounts')
			} else {
				let subStep = isCountryEurope.value
					? 1
					: initialEntity.value === entity.value
						? 2
						: 1
				emit('changeViewStep', subStep)
			}
		}

		const validateShowBoxDisclaimer = () => {
			setTimeout(() => {
				let entityStorage = localStorage.getItem('entityOptions')
				let entitiesArray = []

				if (
					entityStorage &&
					entityStorage !== undefined &&
					entityStorage !== 'undefined'
				) {
					entitiesArray = entityStorage.split(',')
					if (entitiesArray.length === 1) {
						showBoxDisclaimer.value = false
					} else {
						showBoxDisclaimer.value = true
					}
				}
			}, 500)
		}

		watch(accountValue, (newValue) => {
			if (newValue) {
				if (!window.location.pathname.includes('live-account')) {
					window.location.href = '/register/1/live-account' // Recarga la página
				}
			} else {
				if (!window.location.pathname.includes('demo-account')) {
					window.location.href = '/register/1/demo-account' // Recarga la página
				}
			}
		})

		onMounted(() => {
			window.location.pathname.includes('live-account')
				? (accountValue.value = true)
				: (accountValue.value = false)
			validateShowBoxDisclaimer()
		})

		function handleInputChange(value) {
			accountValue.value = value
		}

		return {
			accountCategory,
			countryofRecidency,
			entity,
			initialEntity,
			accountOptions,
			tooltipDirection,
			updateCountryEntity,
			showDisclaimer,
			toggleDisclaimer,
			allowBtn,
			validateEntity,
			accountValue,
			accountsOpt,
			showBoxDisclaimer,
			validateShowBoxDisclaimer,
			handleInputChange
		}
	},
}
</script>

<style>
.col-12 {
	padding: 0px;
}

.app-process-style {
	gap: 15px;
}

.app-process-style .tv__input-label {
	font-weight: 600;
	font-size: 14px;
}
</style>